import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

interface CEOContractProps {
  initialBigPromise?: string;
  initialCustomerFeeling?: string;
  initialCeoOath?: string;
  onSaveBigPromise: (value: string) => void;
  onSaveCustomerFeeling: (value: string) => void;
  onSaveCeoOath: (value: string) => void;
}

export default function CEOContract({
  initialBigPromise = '',
  initialCustomerFeeling = '',
  initialCeoOath = '',
  onSaveBigPromise,
  onSaveCustomerFeeling,
  onSaveCeoOath,
}: CEOContractProps) {
  const [bigPromise, setBigPromise] = useState(initialBigPromise);
  const [customerFeeling, setCustomerFeeling] = useState(initialCustomerFeeling);
  const [ceoOath, setCeoOath] = useState(initialCeoOath);

  useEffect(() => { setBigPromise(initialBigPromise); }, [initialBigPromise]);
  useEffect(() => { setCustomerFeeling(initialCustomerFeeling); }, [initialCustomerFeeling]);
  useEffect(() => { setCeoOath(initialCeoOath); }, [initialCeoOath]);

  const today = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="mx-auto max-w-md"
    >
      <div className="rounded-2xl border-2 border-amber-300 bg-gradient-to-b from-amber-50 to-white p-6 shadow-lg">
        {/* Header */}
        <div className="border-b-2 border-amber-200 pb-4 text-center">
          <span className="text-4xl">💼</span>
          <h2 className="mt-2 text-2xl font-bold text-gray-900">CEO Contract</h2>
          <p className="mt-1 text-xs uppercase tracking-widest text-amber-600">
            Official Business Document
          </p>
        </div>

        {/* Field 1 */}
        <div className="mt-6">
          <label className="text-sm font-bold text-gray-800">
            1. What&apos;s your product&apos;s BIG promise?
          </label>
          <textarea
            value={bigPromise}
            onChange={(e) => {
              setBigPromise(e.target.value);
              onSaveBigPromise(e.target.value);
            }}
            placeholder="We promise to..."
            rows={3}
            className="mt-2 w-full resize-none rounded-lg border-2 border-amber-200 bg-amber-50/50 px-3 py-2 text-gray-900 placeholder-gray-400 focus:border-amber-400 focus:outline-none"
          />
        </div>

        {/* Field 2 */}
        <div className="mt-5">
          <label className="text-sm font-bold text-gray-800">
            2. How do you want people to feel when they use it?
          </label>
          <p className="mt-0.5 text-xs text-gray-400">Use words or emojis to explain.</p>
          <textarea
            value={customerFeeling}
            onChange={(e) => {
              setCustomerFeeling(e.target.value);
              onSaveCustomerFeeling(e.target.value);
            }}
            placeholder="Happy, excited, relieved... 😊"
            rows={3}
            className="mt-2 w-full resize-none rounded-lg border-2 border-amber-200 bg-amber-50/50 px-3 py-2 text-gray-900 placeholder-gray-400 focus:border-amber-400 focus:outline-none"
          />
        </div>

        {/* Field 3 */}
        <div className="mt-5">
          <label className="text-sm font-bold text-gray-800">
            3. CEO oath time! What promise will you keep, even on tough days?
          </label>
          <textarea
            value={ceoOath}
            onChange={(e) => {
              setCeoOath(e.target.value);
              onSaveCeoOath(e.target.value);
            }}
            placeholder="I promise to always..."
            rows={3}
            className="mt-2 w-full resize-none rounded-lg border-2 border-amber-200 bg-amber-50/50 px-3 py-2 text-gray-900 placeholder-gray-400 focus:border-amber-400 focus:outline-none"
          />
        </div>

        {/* Footer */}
        <div className="mt-6 border-t-2 border-amber-200 pt-4 text-center">
          <p className="text-xs text-gray-400">Date: {today}</p>
          <p className="mt-1 text-xs text-amber-600">Officiated by KOKO Business Academy</p>
        </div>
      </div>
    </motion.div>
  );
}
